import { UseFormMethods } from 'react-hook-form';
import React from 'react';
import { Collapse } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { useRemainingShares } from '../../use-owner-shares';

export const RemainingSharesLabel = ({
  control,
}: Pick<UseFormMethods, 'control'>) => {
  const remainingShares = useRemainingShares(control);

  return (
    <React.Fragment>
      <Alert severity="info">
        <strong>Återstående aktier: </strong>{' '}
        {remainingShares < 0 ? 0 : remainingShares}
      </Alert>

      <Collapse in={remainingShares < 0}>
        <Alert style={{ marginTop: '8px' }} severity="error">
          Du har överskridit antalet aktier du har med{' '}
          {Math.abs(remainingShares)}
        </Alert>
      </Collapse>
    </React.Fragment>
  );
};
